"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactAccessibility = require("@nerdwallet/react-accessibility");

var _reactInputGroup = _interopRequireWildcard(require("@nerdwallet/react-input-group"));

var _deprecate = require("@nerdwallet/deprecate");

var _pointerUtils = require("./pointer-utils");

var _nativeSelect = _interopRequireDefault(require("./native-select"));

var _multiselect = _interopRequireDefault(require("./multiselect"));

var _propTypes = require("./prop-types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Renders a select component as a native or dropdown style.
 */
var Select = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var idProp = props.id,
      className = props.className,
      label = props.label,
      helpMessage = props.helpMessage,
      error = props.error,
      errorMessage = props.errorMessage,
      multiple = props.multiple,
      tooltip = props.tooltip,
      tooltipPlacement = props.tooltipPlacement,
      disabled = props.disabled,
      defaultValue = props.defaultValue,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      otherProps = _objectWithoutProperties(props, ["id", "className", "label", "helpMessage", "error", "errorMessage", "multiple", "tooltip", "tooltipPlacement", "disabled", "defaultValue", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling"]);

  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'Select',
    deprecatedProps: [{
      version: '10.5.12',
      deprecated: 'multiple',
      migration: 'Use <CheckboxGroup> to support selecting multiple items.'
    }],
    props: props
  });
  var id = (0, _reactAccessibility.useId)(idProp);
  var errorMessageId = "".concat(id, "-error-message");
  var helpMessageId = "".concat(id, "-help-message"); // It's safe to unconditionally render both IDs in `aria-describedby`, even
  // if there isn't a help/error message currently being shown. If
  // `aria-describedby` refers to an element that doesn't exist, it just skips it.

  var ariaDescribedByIds = "".concat(errorMessageId, " ").concat(helpMessageId); // Native is assumed better UI for coarsely-pointed devices (touch, switch, etc.)

  var DropdownSelectIfBest = (0, _pointerUtils.getPointerType)() === _pointerUtils.COARSE_POINTER ? _nativeSelect["default"] : _multiselect["default"]; // Always default to native for this case

  var SelectComponent = multiple ? DropdownSelectIfBest : _nativeSelect["default"];
  var willRenderInputGroup = (0, _reactInputGroup.shouldRenderInputGroup)(props);

  var select = /*#__PURE__*/_react["default"].createElement(SelectComponent, _extends({
    "aria-describedby": ariaDescribedByIds,
    "aria-invalid": error ? 'true' : undefined,
    id: id,
    error: error,
    className: (0, _classnames["default"])(_defineProperty({}, className, className && !willRenderInputGroup)),
    dangerouslyForceFocusStyling: dangerouslyForceFocusStyling,
    dangerouslyForceHoverStyling: dangerouslyForceHoverStyling,
    disabled: disabled,
    multiple: multiple,
    innerRef: ref
  }, otherProps));

  if (!willRenderInputGroup) {
    return select;
  }

  return /*#__PURE__*/_react["default"].createElement(_reactInputGroup["default"], {
    className: className,
    disabled: disabled,
    error: error,
    errorMessage: errorMessage,
    errorMessageId: errorMessageId,
    helpMessage: helpMessage,
    helpMessageId: helpMessageId,
    input: select,
    inputId: id,
    label: label,
    tooltip: tooltip,
    tooltipPlacement: tooltipPlacement
  });
});

Select.displayName = 'Select';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Select.propTypes = _objectSpread({
    /** An array of options `[{ value, label }]`. See example. */
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
      disabled: PropTypes.bool,

      /** Silence the maxLineLength error to allow a label > 21 characters. Generally only used in instances where copy or compliance requires them. */
      __dangerouslyAllowLongLabel: PropTypes.bool
    })),

    /** The currently selected value. Must match a provided option. */
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.bool, PropTypes.number, PropTypes.string]),

    /** Show the select in an error visual state. */
    error: PropTypes.bool,

    /** Optional label for the select. */
    label: PropTypes.string,

    /** Optional text to be shown indicating the user is in an error state. */
    errorMessage: PropTypes.node,

    /** Optional help text shown below the input. */
    helpMessage: PropTypes.node,

    /** Optional tooltip shown via an icon next to the label. */
    tooltip: PropTypes.node,

    /** Positioning of tooltip. */
    tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

    /** When true, sets width to 100% on the input. */
    fullWidth: PropTypes.bool,

    /** Shows a disabled style. */
    disabled: PropTypes.bool,

    /**
     * Allows selecting multiple options.
     * @deprecated
     */
    multiple: PropTypes.bool,

    /** Id attribute for select element. */
    id: PropTypes.string.isRequired,

    /** Name attribute for select element. */
    name: PropTypes.string,

    /** Value change callback. */
    onChange: PropTypes.func,

    /** Callback on close, browser mutliselect only */
    onClose: PropTypes.func,

    /** Focus callback. */
    onFocus: PropTypes.func,

    /** Blur callback. */
    onBlur: PropTypes.func,

    /** Callback on open, browser mutliselect only */
    onOpen: PropTypes.func,

    /**
     * The initial value when state is uncontrolled. Must match a provided
     * option.
     */
    defaultValue: PropTypes.string,

    /** Class on the <input> element. */
    className: PropTypes.string,

    /** Force the component to use its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Force the component to use its hover styles. */
    dangerouslyForceHoverStyling: PropTypes.bool
  }, _propTypes.SELECT_PROP_TYPES);
}

Select.defaultProps = _objectSpread({
  label: null,
  errorMessage: null,
  helpMessage: null,
  tooltip: null,
  tooltipPlacement: null
}, _propTypes.SELECT_DEFAULT_PROPS);
var _default = Select;
exports["default"] = _default;